import styled from "styled-components";
import { apiGet, BASE_URL } from "../../store/api";
import { RootState } from "../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { updateMessage } from "../../reducers/authorization/authorization.actions";

export const PermissionBlockedPage = () => {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.authorization.token);
  
  const logout = () => {
    apiGet(`${BASE_URL}account/logout`, token).finally(() => {
      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      dispatch(updateMessage('logout_ok'));
    });
  }
  
  return (
    <PermissionBlockedPageWrapper>
      <section className="content">
        <section className="content">
          <div className="row">
            <div className="col-lg-4"></div>
            <div className="col-lg-4">
              <div className="box">
                <div className="box-body">
                  <h5><b>Anda tidak memiliki akses untuk halaman ini!</b></h5>
                  <p>Silahkan mencoba untuk masuk kembali atau menghubungi tim International Office untuk mendapatkan akses.</p>
                  <p>
                    <button className="btn btn-danger" onClick={() => logout()}>
                      <i className="fa fa-envelope-o"></i> &nbsp;
                      <span>KELUAR</span>
                    </button>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4"></div>
          </div>
        </section>
      </section>
    </PermissionBlockedPageWrapper>
  )
}

const PermissionBlockedPageWrapper = styled.div`
  
`;